export function scrollDown (ref) {
    window.scrollTo({
      top: ref.current.offsetTop - 400,
      behavior: 'smooth',
    });
  };